import { formatUnits } from 'viem';
import { USD } from '../constants';

export function formatNumber(n: number | string, f: number = 3): string {
  n = Number(n);
  if (n < 1e3) return Number(n.toFixed(f)).toString();
  if (n < 1e6) return Number((n / 1e3).toFixed(f)).toString() + 'k';
  if (n < 1e9) return Number((n / 1e6).toFixed(f)).toString() + 'm';
  if (n < 1e12) return Number((n / 1e9).toFixed(f)).toString() + 'b';
  return Number((n / 1e12).toFixed(f)).toString() + 't';
}

export function localeNumber(
  n: number | string,
  options?: { maximumFractionDigits?: number },
): string {
  return Number(n).toLocaleString('ru-RU', {
    maximumFractionDigits: 6,
    roundingMode: 'floor',
    ...options,
  });
}

export function parseNumber(
  n: string | bigint,
  options?: { maximumFractionDigits?: number },
): string {
  const value = formatUnits(BigInt(n), USD.decimals);
  return localeNumber(value, options);
}
